(function () {
  // Live date/time stamp under the menu, e.g. 10/21/2026 1:04 PM
  var clock = document.querySelector('[data-clock]');
  if (clock) {
    var tick = function () {
      var d = new Date();
      var date = d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
      var time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
      clock.textContent = date + ' ' + time;
    };
    tick();
    setInterval(tick, 30000);
  }

  // Variant picker on the product page
  var form = document.getElementById('product-form');
  var dataEl = document.querySelector('[data-variants]');
  if (!form || !dataEl) return;

  var variants = JSON.parse(dataEl.textContent);
  var idInput = form.querySelector('[data-variant-id]');
  var addBtn = form.querySelector('[data-add]');
  var priceEl = document.querySelector('[data-price]');

  function formatMoney(cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: fmt }).format(cents / 100) + ' ' + fmt;
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + fmt;
    }
  }

  function update() {
    var chosen = [];
    form.querySelectorAll('input[data-option]:checked').forEach(function (el) {
      chosen[Number(el.dataset.option) - 1] = el.value;
    });
    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    if (!match) {
      addBtn.disabled = true;
      addBtn.textContent = 'unavailable';
      return;
    }
    idInput.value = match.id;
    priceEl.textContent = formatMoney(match.price);
    addBtn.disabled = !match.available;
    addBtn.textContent = match.available ? (addBtn.dataset.label || 'add to cart') : 'sold out';
    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url);
  }

  form.addEventListener('change', update);
})();

// scroll reveal
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.12 });
  els.forEach(function (e, i) { e.style.transitionDelay = (i % 4) * 80 + 'ms'; io.observe(e); });
})();
